import { BuzerIcon, ICON_NAMES } from "../../BuzerIcons";
import { resolveIcon } from "../../lib/icons-resolve";
import { fmtDuePretty } from "../../lib/date-sk";

// v9 — a due-date label with the calendar BuzerIcon (replaces the legacy "📅 " text prefix).
export function DueLabel({ due, end, none = "" }) {
  if (!due) return none ? <>{none}</> : null;
  return <><BuzerIcon name="calendar" size={12} color="var(--muted)" style={{ verticalAlign: "-2px", marginRight: 3 }} />{fmtDuePretty(due, end)}</>;
}

// v8 — render a habit/category glyph: a BuzerIcon if `icon` is a set name or a known legacy emoji,
// else the raw emoji string as a last resort.
export function Glyph({ icon, size = 22, fallback = "target" }) {
  const name = resolveIcon(icon) || (!icon ? fallback : "");
  if (name && ICON_NAMES.includes(name)) return <BuzerIcon name={name} size={size} />;
  return <span>{icon || fallback}</span>;
}
